/* ADSCALAR — display-currency switcher.

   Port of the Hydrogen reference's behaviour (read off the live site
   2026-09-07): the shopper picks a display currency, every rupee amount on the
   page is converted for READING ONLY, and a note states the rupee amount that
   will actually be charged. Checkout stays INR.

   Why not Shopify Markets: this store has many countries enabled but a single
   currency, so the native country picker listed dozens of countries all showing
   ₹ INR — which is what it was replaced for. Markets can be layered on later
   without touching this; the note simply becomes redundant.

   Rates are INR per one unit, overridable from Theme settings → Display
   currency, since they drift. */
(function () {
  var KEY = 'ek_display_currency';
  var BASE = 'INR';

  // Selector chrome only. Intl is left to format the prices themselves (it
  // yields CA$102.39 / SGD 93.86 / AED 272.01, matching the reference), but its
  // "symbol" for AED and SGD is just the code again, which read as "AED AED".
  var SYMBOLS = {
    INR: '\u20B9', USD: '$', GBP: '\u00A3', AED: '\u062F.\u0625',
    CAD: 'C$', SGD: 'S$', AUD: 'A$'
  };

  var DEFAULTS = [
    { code: 'INR', name: 'Indian Rupee',     rate: 1 },
    { code: 'USD', name: 'US Dollar',        rate: 94.5052 },
    { code: 'GBP', name: 'British Pound',    rate: 127.7606 },
    { code: 'AED', name: 'UAE Dirham',       rate: 25.7344 },
    { code: 'CAD', name: 'Canadian Dollar',  rate: 68.3660 },
    { code: 'SGD', name: 'Singapore Dollar', rate: 74.5792 },
    { code: 'AUD', name: 'Australian Dollar', rate: 68.0669 }
  ];

  var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-asc-currency]'));
  if (!wraps.length) return;

  function partsFor(wrap) {
    return {
      toggle: wrap.querySelector('[data-asc-currency-toggle]'),
      menu: wrap.querySelector('[data-asc-currency-menu]')
    };
  }

  // "USD 94.5, GBP 127.76" from Theme settings overrides the shipped rates.
  var list = DEFAULTS.map(function (c) { return { code: c.code, name: c.name, rate: c.rate }; });
  (function applyOverrides() {
    var raw = wraps[0].getAttribute('data-rates') || '';
    if (!raw.trim()) return;
    raw.split(',').forEach(function (pair) {
      var bits = pair.trim().split(/[\s:=]+/);
      var code = (bits[0] || '').toUpperCase();
      var rate = parseFloat(bits[1]);
      if (!code || !isFinite(rate) || rate <= 0) return;
      var hit = list.filter(function (c) { return c.code === code; })[0];
      if (hit) hit.rate = rate;
      else list.push({ code: code, name: code, rate: rate });
    });
  })();

  function rateFor(code) {
    var hit = list.filter(function (c) { return c.code === code; })[0];
    return hit ? hit.rate : null;
  }

  function fmt(amountInr, code) {
    var r = rateFor(code);
    if (!r) return null;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: code,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amountInr / r);
    } catch (e) { return null; }
  }

  function symbolFor(code) {
    if (SYMBOLS[code]) return SYMBOLS[code];
    try {
      var parts = new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).formatToParts(0);
      for (var i = 0; i < parts.length; i++) if (parts[i].type === 'currency') return parts[i].value;
    } catch (e) {}
    return '';
  }

  function stored() {
    try { return localStorage.getItem(KEY) || BASE; } catch (e) { return BASE; }
  }
  function store(code) {
    try { localStorage.setItem(KEY, code); } catch (e) {}
  }

  var active = rateFor(stored()) ? stored() : BASE;

  /* ── Conversion ───────────────────────────────────────────────────────────
     Rupee amounts are rewritten in place. Each text node's untouched original
     is kept, so switching back is exact rather than a re-conversion of a
     converted number. */
  var originals = new WeakMap();
  var MONEY = /₹\s?\d[\d,]*(?:\.\d+)?/g;
  var SKIP = 'script,style,noscript,textarea,input,select,option,[data-no-currency],[data-asc-currency]';

  function convertNode(node, code) {
    var src = originals.has(node) ? originals.get(node) : node.nodeValue;
    if (!MONEY.test(src)) { MONEY.lastIndex = 0; return; }
    MONEY.lastIndex = 0;
    if (!originals.has(node)) originals.set(node, src);

    if (code === BASE) {
      if (node.nodeValue !== src) node.nodeValue = src;
      return;
    }
    var out = src.replace(MONEY, function (m) {
      var n = parseFloat(m.replace(/[₹,\s]/g, ''));
      if (!isFinite(n)) return m;
      return fmt(n, code) || m;
    });
    if (node.nodeValue !== out) node.nodeValue = out;
  }

  function walk(root, code) {
    if (!root) return;
    if (root.nodeType === 3) { convertNode(root, code); return; }
    if (root.nodeType !== 1) return;
    if (root.closest && root.closest(SKIP)) return;

    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('₹') === -1) {
          if (!originals.has(n)) return NodeFilter.FILTER_REJECT;
        }
        var p = n.parentElement;
        if (p && p.closest(SKIP)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var batch = [];
    while (tw.nextNode()) batch.push(tw.currentNode);
    batch.forEach(function (n) { convertNode(n, code); });
  }

  /* Checkout note. Each anchor names the element holding the real rupee amount,
     so the note stays right through variant changes and cart re-renders. */
  function notes(code) {
    document.querySelectorAll('[data-asc-inr-note]').forEach(function (el) {
      var sel = el.getAttribute('data-src');
      var src = sel ? document.querySelector(sel) : null;
      if (code === BASE || !src) { el.hidden = true; el.textContent = ''; return; }
      var txt = '';
      src.childNodes.forEach(function (n) {
        if (n.nodeType === 3) txt += originals.has(n) ? originals.get(n) : n.nodeValue;
      });
      txt = (txt || '').trim();
      if (!txt) { el.hidden = true; return; }
      el.textContent = 'Charged in ' + txt + ' at checkout';
      el.hidden = false;
    });
  }

  function apply(code) {
    walk(document.body, code);
    notes(code);
    wraps.forEach(function (wrap) {
      var parts = partsFor(wrap);
      var toggle = parts.toggle;
      var menu = parts.menu;
      if (!toggle || !menu) return;

      toggle.innerHTML = '';
      var sym = document.createElement('span');
      sym.className = 'sym';
      sym.textContent = symbolFor(code);
      var cd = document.createElement('span');
      cd.className = 'code';
      cd.textContent = code;
      toggle.appendChild(sym);
      toggle.appendChild(cd);
      toggle.insertAdjacentHTML('beforeend',
        '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');
      toggle.setAttribute('aria-label', 'Currency: ' + code + '. Change display currency');
      menu.querySelectorAll('[data-asc-cur]').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-asc-cur') === code ? 'true' : 'false');
        if (b.parentElement) b.parentElement.setAttribute('aria-selected', b.getAttribute('data-asc-cur') === code ? 'true' : 'false');
      });
    });
  }

  // Build and bind every selector (desktop header + mobile drawer) from one source.
  function closeWrap(wrap) {
    var parts = partsFor(wrap);
    if (!parts.toggle || !parts.menu) return;
    if (wrap.tagName === 'DETAILS') wrap.removeAttribute('open');
    else parts.menu.hidden = true;
    parts.toggle.setAttribute('aria-expanded', 'false');
  }

  wraps.forEach(function (wrap) {
    var parts = partsFor(wrap);
    var toggle = parts.toggle;
    var menu = parts.menu;
    if (!toggle || !menu) return;

    menu.innerHTML = list.map(function (c) {
      return '<li role="option" aria-selected="' + (c.code === active) + '">' +
        '<button type="button" data-asc-cur="' + c.code + '">' +
          '<span class="sym">' + symbolFor(c.code) + '</span>' +
          '<span class="code">' + c.code + '</span>' +
          '<span class="cn">' + c.name + '</span>' +
        '</button></li>';
    }).join('');

    if (wrap.tagName === 'DETAILS') {
      wrap.addEventListener('toggle', function () {
        if (wrap.open) wraps.forEach(function (other) { if (other !== wrap) closeWrap(other); });
        toggle.setAttribute('aria-expanded', wrap.open ? 'true' : 'false');
      });
    } else {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = menu.hidden;
        wraps.forEach(function (other) { if (other !== wrap) closeWrap(other); });
        menu.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }

    menu.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-asc-cur]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      active = btn.getAttribute('data-asc-cur');
      store(active);
      apply(active);
      wraps.forEach(closeWrap);
    });
  });

  document.addEventListener('click', function (e) {
    wraps.forEach(function (wrap) {
      if (!wrap.contains(e.target)) closeWrap(wrap);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    wraps.forEach(function (wrap) {
      var parts = partsFor(wrap);
      if (parts.menu && !parts.menu.hidden) {
        closeWrap(wrap);
        if (parts.toggle) parts.toggle.focus();
      }
    });
  });

  // Cart drawer, search results and wishlist all inject markup after load.
  var pending = null;
  var obs = new MutationObserver(function (muts) {
    if (active === BASE) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      muts.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) walk(m.addedNodes[i], active);
      });
      notes(active);
    }, 40);
  });

  apply(active);
  obs.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('ek:cart-rendered', function () { setTimeout(function () { apply(active); }, 30); });
})();
